


import React from 'react';
import { Card, CardContent, CardActionArea, Typography, IconButton  } from '@mui/material';

import { FaYoutube } from 'react-icons/fa'

const Video = ({id, title}) => {

    return (<>
        <iframe
            src={`https://www.youtube-nocookie.com/embed/${id}`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            style={{ width: '100%', height: '215px' }}
            ></iframe>
            <Typography mb={3}><FaYoutube/> {title}</Typography>
        </>
    )
}
export default Video;